<template>
    <div class="main">
        <div class="body-content">
            <div class="page-header">
                <h1>Upload EGM</h1>
            </div>
            <div class="form-group">
                <div class="form-item">
                    <label for="fileAdd">File:</label>
                    <input type="file" id="file" @change="handleFileUpload" class="custom-file-input">
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Upload</button>
                </div>
            </div>
            <div v-if="transactions.length === 0" class="no-data">
                <p>No data available</p>
            </div>
            <div v-else>
                <div class="table-container">
                    <table class="transaction-table table-design">
                        <thead>
                            <tr>
                                <th>
                                    <span>Sl No</span>
                                </th>
                                <th>
                                    <span>Container</span>
                                </th>
                                <th style="width:20px">
                                    <span>SB No</span>
                                </th>
                                <th>
                                    <span>SB Date</span>
                                </th>
                                <th>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(transaction, index) in transactions" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ transaction.container }}</td>
                                <td>{{ transaction.sbno }}</td>
                                <td>{{ transaction.sbdate }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="savequery" :disabled="isSubmitting">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { useToast } from 'vue-toastification';



export default {
    data() {
        return {
            transactions: [],
            isSubmitting: false,
            newContainer: {
                file: null
            }
        };
    },
    methods: {
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async uploadFiles() {
            if (this.isSubmitting) return;
            
            if (this.newContainer.file == null) {
                useToast().error("Select file");
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                };
                const data = new FormData();
                data.append('file', this.newContainer.file);
                const response = await axios.post('/tprc_final_loading', data, config);
                console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success("File uploaded successfully");
                    this.transactions = response.data[2]
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                useToast().error(error.response?.data?.message || 'Error uploading file.');
            } finally {
                this.isSubmitting = false;
            }
        }, 
        async savequery() {
            if (this.isSubmitting) return;
            
            if (this.transactions === null || this.transactions.length === 0) {
                useToast().error('Please upload a file first');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                };
                const qrydata = {
                    qry: this.transactions
                }
                const data = new FormData();
                const transdt = JSON.stringify(qrydata)
                data.append('transaction', transdt)
    
                const response = await axios.post('/save_tprc_final_loading', data, config);
                console.log(response.data)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    useToast().success(response.data[1]);
                    this.transactions = []
                }
            } catch (error) {
                console.error('Error saving data:', error);
                useToast().error(error.response?.data?.message || 'Error saving data.');
            } finally {
                this.isSubmitting = false;
            }
        },
    }
}
</script>
<style scoped>
.form-item {
    width: 30%;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>